import React, { useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
} from "@mui/material";
import { CiGrid41, CiViewTable } from "react-icons/ci";
import { TiFlowMerge } from "react-icons/ti";
import Reportee from "../../../components/Dashboard/Team/Reportees/Reportee";
import { useTheme } from "../../../style/theme";
import KanbanView from "../../../components/Dashboard/Team/Reportees/KanbanView ";
import { IoFilterSharp } from "react-icons/io5";

const Reportees = () => {
  const [view, setView] = useState({ first: "all", second: "grid" });
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [kanbanView, setKanbanView] = useState("seniority");
  const [expandedSections, setExpandedSections] = useState({
    "0-5": false,
    "5-10": false,
    above10: false,
  });

  // Function to toggle the visibility of each section
  const toggleSection = (seniority) => {
    setExpandedSections((prev) => ({
      ...prev,
      [seniority]: !prev[seniority], // Toggle the clicked seniority section
    }));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMenuItemClick = (value) => {
    setKanbanView(value); // <-- new line
    setOpen(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const arr = [
    {
      img_url: "/images/profileImg1.png",
      name: "Amanda Throne",
      attendence: "Present",
      role: "Software Developer",
      time: "Clocked-In",
      email: "richardwebber@clikkmail.com",
      date: "22/10/2024",
      age: 3, // Added age
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Amina Kumar",
      attendence: "Absent",
      role: "QA Tester",
      time: "Not Yet Clocked-In",
      email: "desmondjakes@clikkmail.com",
      date: "22/10/2024",
      age: 7, // Added age
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Daniel Thompson",
      attendence: "Leave",
      role: "Frontend Developer",
      time: "Not Yet Clocked-In",
      email: "jaxsonschleifer@clikkmail.com",
      date: "22/10/2024",
      age: 5, // Added age
    },
    {
      img_url: "/images/profileImg4.png",
      name: "Dave Maxwell",
      attendence: "Present",
      role: "Frontend Developer",
      time: "Clocked-In",
      email: "amandathrone@clikkmail.com",
      date: "22/10/2024",
      age: 6, // Added age
    },
    {
      img_url: "/images/profileImg5.png",
      name: "Dwayne Graham",
      attendence: "Present",
      role: "Backend Developer",
      time: "Clocked-In",
      email: "erinherwitz@clikkmail.com",
      date: "22/10/2024",
      age: 8, // Added age
    },
    {
      img_url: "/images/profileImg1.png",
      name: "Amanda Throne",
      attendence: "Present",
      role: "Software Developer",
      time: "Clocked-In",
      email: "richardwebber@clikkmail.com",
      date: "22/10/2024",
      age: 3, // Added age
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Amina Kumar",
      attendence: "Absent",
      role: "QA Tester",
      time: "Not Yet Clocked-In",
      email: "desmondjakes@clikkmail.com",
      date: "22/10/2024",
      age: 7, // Added age
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Daniel Thompson",
      attendence: "Leave",
      role: "Frontend Developer",
      time: "Not Yet Clocked-In",
      email: "jaxsonschleifer@clikkmail.com",
      date: "22/10/2024",
      age: 5, // Added age
    },
    {
      img_url: "/images/profileImg4.png",
      name: "Dave Maxwell",
      attendence: "Present",
      role: "Frontend Developer",
      time: "Clocked-In",
      email: "amandathrone@clikkmail.com",
      date: "22/10/2024",
      age: 6, // Added age
    },
    {
      img_url: "/images/profileImg5.png",
      name: "Dwayne Graham",
      attendence: "Present",
      role: "Backend Developer",
      time: "Clocked-In",
      email: "erinherwitz@clikkmail.com",
      date: "22/10/2024",
      age: 8, // Added age
    },
    {
      img_url: "/images/profileImg1.png",
      name: "Amanda Throne",
      attendence: "Present",
      role: "Software Developer",
      time: "Clocked-In",
      email: "richardwebber@clikkmail.com",
      date: "22/10/2024",
      age: 3, // Added age
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Amina Kumar",
      attendence: "Absent",
      role: "QA Tester",
      time: "Not Yet Clocked-In",
      email: "desmondjakes@clikkmail.com",
      date: "22/10/2024",
      age: 7, 
    },
    {
      img_url: "/images/profileImg2.png",
      name: "Daniel Thompson",
      attendence: "Leave",
      role: "Frontend Developer",
      time: "Not Yet Clocked-In",
      email: "jaxsonschleifer@clikkmail.com",
      date: "22/10/2024",
      age: 5, 
    },
    {
      img_url: "/images/profileImg4.png",
      name: "Dave Maxwell",
      attendence: "Present",
      role: "Frontend Developer",
      time: "Clocked-In",
      email: "amandathrone@clikkmail.com",
      date: "22/10/2024",
      age: 6, 
    },
    {
      img_url: "/images/profileImg5.png",
      name: "Dwayne Graham",
      attendence: "Present",
      role: "Backend Developer",
      time: "Clocked-In",
      email: "erinherwitz@clikkmail.com",
      date: "22/10/2024",
      age: 8, // Added age
    },
    {
      img_url: "/images/profileImg4.png",
      name: "Dave Maxwell",
      attendence: "Present",
      role: "Frontend Developer",
      time: "Clocked-In",
      email: "amandathrone@clikkmail.com",
      date: "22/10/2024",
      age: 23, // Added age
    },
    {
      img_url: "/images/profileImg5.png",
      name: "Dwayne Graham",
      attendence: "Present",
      role: "Backend Developer",
      time: "Clocked-In",
      email: "erinherwitz@clikkmail.com",
      date: "22/10/2024",
      age: 22, // Added age
    },
  ];

  const filteredArr = view.first === "direct" ? arr.slice(0, 4) : arr;

  const filterData = (seniority) => {
    const filteredData = [];

    if (seniority === "0-5") {
      filteredData.push(
        ...arr.filter((item) => item.age >= 0 && item.age <= 5)
      );
    } else if (seniority === "5-10") {
      filteredData.push(
        ...arr.filter((item) => item.age > 5 && item.age <= 10)
      );
    } else if (seniority === "above10") {
      filteredData.push(...arr.filter((item) => item.age > 10));
    }

    // Return filtered data (already done above)
    return filteredData;
  };

  // Now let's calculate the counts separately
  const count0to5 = arr.filter((item) => item.age >= 0 && item.age <= 5).length;
  const count5to10 = arr.filter(
    (item) => item.age > 5 && item.age <= 10
  ).length;
  const countAbove10 = arr.filter((item) => item.age > 10).length;

  // Log the counts if you need to check them
  console.log("Count 0-5 years:", count0to5);
  console.log("Count 5-10 years:", count5to10);
  console.log("Count above 10 years:", countAbove10);

  const buttonMapping = [
    {
      title: "Grid View",
      value: { ...view, second: "grid" },
      child: <CiGrid41 />,
    },
    {
      title: "Table View",
      value: { ...view, second: "table" },
      child: <CiViewTable />,
    },
    {
      title: "Kanban View",
      value: { ...view, second: "kanban" },
      child: (
        <>
          <div id="demo-positioned-button" onClick={handleClick}>
            <TiFlowMerge />
          </div>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}  
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem onClick={() => handleMenuItemClick("seniority")}>
              Seniority
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("department")}>
              Department
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("designation")}>
              Designation
            </MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  const { mode } = useTheme();

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Top Buttons */}
      
      <div className="w-full flex flex-row gap-9 justify-end items-center">
        {/* Left Tabs */}
        <div className="flex flex-row gap-2">
          <Button
            variant={view.first === "all" ? "contained" : "outlined"}
            onClick={() => setView({ ...view, first: "all" })}
            sx={{
              height: { xs: "30px", sm: "auto" },
              padding: { xs: "5px", sm: "8px 16px" },
            }}
          >
            <div className="text-[10px] md:text-[14px]">All {arr.length}</div>
          </Button>
          <Button
            variant={view.first === "direct" ? "contained" : "outlined"}
            onClick={() => setView({ ...view, first: "direct" })}
            sx={{
              height: { xs: "30px", sm: "auto" },
              padding: { xs: "5px", sm: "8px 16px" },
            }}
          >
            <div className="text-[10px] md:text-[14px]">Direct 4</div>
          </Button>
        </div>

        {/* Right View Buttons */}
        <div className="flex flex-row gap-2 justify-center items-center">
          {buttonMapping.map((button, index) => (
            <Button
              key={index}
              title={button.title}
              variant={
                view.second === button.value.second ? "contained" : "outlined"
              }
              onClick={() => setView({ ...view, second: button.value.second })}
              sx={{
                height: { xs: "30px", sm: "auto" },
                padding: { xs: "5px", sm: "8px 16px" },
              }}
            >
              <div className="sm:text-2xl text-[16px]">{button.child}</div>
            </Button>
          ))}
        </div>

        <div>
        <Button
              variant="outlined"
              sx={{
                height: { xs: "30px", sm: "auto" },
                padding: { xs: "5px", sm: "8px 16px" },
              }}
            >
              <div className="sm:text-2xl text-[16px]">
                <IoFilterSharp />
              </div>
            </Button>
        </div>
      </div>

      <div className="w-full">
        <div className="w-full sm:grid sm:gap-3 sm:grid-cols-3 justify-center items-center place-content-center place-items-center place-self-center">
          {view.second === "grid" && <Reportee arr={filteredArr} view={view} />}
        </div>

        {view.second === "table" && (
          <div className="overflow-x-auto border-[#1e2734] rounded-md border">
            <div className="flex items-center gap-2 px-3 py-3">
              Rows per page
              <FormControl size="small" sx={{ minWidth: 60 }}>
                <Select
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border from notchedOutline
                    },
                    "& .MuiSelect-select": {
                      padding: "8px 10px", // Optional: adjust padding if needed
                    },
                  }}
                  label="Rows per page"
                  defaultValue="10"
                >
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="20">20</MenuItem>
                  <MenuItem value="30">30</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="px-3">
              <table className="min-w-full text-left text-sm px-2">
                <thead className="bg-[#171717] text-[20px]">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Employee
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Status
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Designation
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Email
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Date of Joining
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredArr.map((item, index) => (
                    <tr key={index} className="">
                      <td className="px-6 py-2">
                        <div className="flex items-center gap-2">
                          <img
                            src={item.img_url}
                            alt={item.name}
                            className="w-10 h-10 rounded-full"
                          />
                          <div className="text-[18px]">{item.name}</div>
                        </div>
                      </td>

                      <td className="px-6 py-2 text-[14px]">{item.time}</td>
                      <td className="px-6 py-2 text-[14px]">{item.role}</td>
                      <td className="px-6 py-2 text-[14px]">{item.email}</td>
                      <td className="px-6 py-2 text-[14px]">{item.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {view.second === "kanban" && (
          <div className="w-full flex flex-col gap-4">
            {kanbanView === "seniority" && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div
                    className="border rounded-lg p-4 border-[#1e2734]"
                    onClick={() => toggleSection("0-5")}
                  >
                    <div className="flex items-center justify-between px-4 ">
                      <p> 0 - 5 Years</p>
                      <p>{count0to5}</p>
                    </div>
                    
                    {expandedSections["0-5"] && (
                        <KanbanView filteredData={filterData("0-5")} />
                      )}
                  </div>

                  <div
                    className="border rounded-lg p-4 border-[#1e2734]"
                    onClick={() => toggleSection("5-10")}
                  >
                    <div className="flex items-center justify-between px-4 ">
                      <p> 5 - 10 Years</p>
                      <p>{count5to10}</p>
                    </div>
                    
                    {expandedSections["5-10"] && (
                        <KanbanView filteredData={filterData("5-10")} />
                      )}
                      
                  </div>

                  <div
                    className="border rounded-lg p-4 border-[#1e2734]"
                    onClick={() => toggleSection("above10")}
                  >
                    <div className="flex items-center justify-between px-4 ">
                      <p> Above 10 Years</p>
                      <p>{countAbove10}</p>
                    </div>
                    
                    {expandedSections["above10"] && (
                        <KanbanView filteredData={filterData("above10")} />
                      )}
                     
                  </div>
                </div>
              </>
            )}

            {kanbanView === "department" && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div
                className="border rounded-lg p-4 border-[#1e2734]"
              >
               
               <p> IT</p>

              </div>

              <div
                className="border rounded-lg p-4 border-[#1e2734]"
              >
                <p>Marketing</p>
                
              </div>

              <div
                className="border rounded-lg p-4 border-[#1e2734]"
              >
                
                <p>Management</p>
              </div>
            </div>
            )}

            {kanbanView === "designation" && (
               <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
               <div
                 className="border rounded-lg p-4 border-[#1e2734]"
               >
                
                <p> Team Member</p>
 
               </div>
 
               <div
                 className="border rounded-lg p-4 border-[#1e2734]"
               >
                 <p>Administration</p>
                 
               </div>
 
               <div
                 className="border rounded-lg p-4 border-[#1e2734]"
               >
                 
                 <p>Assistant Manager</p>
               </div>
             </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Reportees;
